module.exports = __webpack_public_path__ + "img/undraw_traveling_re_weve.95e155db.svg";